import { Action, ActionCreator } from 'redux';

export enum APIActionTypes {
    API_LOAD_NEEDED = 'API_LOAD_NEEDED'
}

export interface APILoadNeeded extends Action {
    type: APIActionTypes.API_LOAD_NEEDED;
    payload: {
        loadNeeded: boolean;
    };
}

export type APIAction = APILoadNeeded;

export const apiLoadNeeded: ActionCreator<APILoadNeeded> = (isNeeded: boolean) => {
    return {
        type: APIActionTypes.API_LOAD_NEEDED,
        payload: {
            loadNeeded: isNeeded
        }
    };
};
